import { Component } from '@angular/core';
import { VariableService } from '../services/sharedVariables';
import { Privileges } from '../models/privileges.model';

@Component({
  selector: 'side-bar',
  templateUrl: '../views/page-sections/sidebar.html'
})
export class SideBarComponent{
  public title:string;
  public user:string;
  public privileges:Privileges[];

  constructor(private sharedVariables: VariableService)
  {
    this.user="";
    this.title = "Sidebar";
  }

  ngOnInit()
  {
    this.getPrivileges();
  }
  getPrivileges()
  {
    this.sharedVariables.getPrivileges().subscribe(
        response => {
          if(response.code == 200){
            this.user = response.data[0].name;
            console.log("Privilegios del usuario",this.user);
          }
        },error =>{
          console.log(<any>error);
        }
    );
  }
}



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/components/sidebar.component.ts